import React, {useContext} from 'react';
import {Flex} from 'reflexbox';
import {renderLine} from '../FlightTimes/FlightTimes'
import './FlightItinerary.scss';
import {StoreContext} from '../../helpers/StoreContext';

export default (props)=> {

  const flightDetails = props.flightDetails;
  const displayStore = useContext(StoreContext).displayStore;
  const firstRowWidth = 0.3;
  const centerRowWidth = 0.2;
  const lastRowWidth = 0.5;
  const numFlights = flightDetails.length;

  return (
    <Flex flexDirection="column" className="flight-itinerary">
        {flightDetails.map((entry, index) => {
          const arrival = entry.arrival;
          const arrivalDate = new Date(arrival.time);
          const departure = entry.departure;
          const departureDate = new Date(departure.time);
          const stopoverHours = Math.floor(entry.stopoverDuration / 60).toString().padStart(2,'0');
          const stopoverMinutes = (entry.stopoverDuration % 60);
          const stopoverString = entry.stopoverDuration > 0  ? <span>Aufenthalt:<br/>{stopoverHours}h {stopoverMinutes}min</span>  : null;

          return (
              // flight start
              [renderLine(
                {width: firstRowWidth, content: [
                    <div key={"1-" + departureDate}>{displayStore.getTime(departureDate)}</div>,
                    <div className="bold" key={"0-" + departureDate}>{displayStore.getShortDate(departureDate)}</div>,
                  ]},
                {width: centerRowWidth, content: (<span className={"vertical line dot solid" + (index === 0 ? " first" : "")}  />)},
                {width: lastRowWidth, content: [
                    <div key={"airport-" + departure.airport.code} className="bold">{departure.airport.name + " (" + departure.airport.code+")"}</div>,
                    <div key={"airline-" + entry.airline.code} className="light">{entry.airline.name + " ("+entry.airline.code+")"}</div>,
                    <div key={"class-" + entry.class} className="light">{entry.class}</div>
                  ]},
                0,
                "flight-start"

              ),
              // flight end
              renderLine(
                {width: firstRowWidth, content: [
                    <div key={"time-"+arrivalDate}>{displayStore.getTime(arrivalDate)}</div>,
                    <div key={"date-"+arrivalDate}>{displayStore.getShortDate(arrivalDate)}</div>,
                  ]},
                {width: centerRowWidth, content: (<span className={"vertical line dot" + (numFlights -1 === index ? " last" : "")} />)},
                {width: lastRowWidth, content: [
                    <div key={"airport-" + arrival.airport.code}>{arrival.airport.name + " ("+arrival.airport.code+")"}</div>,
                    <div key={"stopover-" + entry.stopoverDuration}>{stopoverString}</div>
                  ]},
                1,
                "flight-end"
              )])
        })}
    </Flex>
  )
}
